/**
 * Route-level permission guards. Production-enforced.
 *
 * Each entry maps a URL prefix to the permission key required for access.
 * Ordered by specificity (most specific prefixes first) so `.find()` matches correctly.
 *
 * Source of truth for permission keys: src/config/adminPermissionMatrix.ts
 * Enforcement point: src/pages/admin/AdminLayout.tsx (renders <PermissionDenied/>
 * when the current admin's role_permissions do not include the required key).
 *
 * super_admin short-circuits all guards (see src/hooks/usePermissions.ts).
 *
 * DO NOT clear this array for demo/dev convenience. Seed user_roles +
 * role_permissions for the test admin instead.
 */
export const GUARDED_ROUTE_PREFIXES: [string, string][] = [
  // Compliance & Financial Crime
  ['/admin/compliance', 'compliance.view'],
  ['/admin/risk-matrix', 'compliance.view'],
  ['/admin/policies', 'compliance.view'],

  // Treasury & FX Desk
  ['/admin/treasury', 'treasury.view'],

  // Security & Access
  ['/admin/security', 'security.view'],
  ['/admin/approvals', 'security.view'],

  // ISO 27001
  ['/admin/iso', 'iso.view'],

  // Integrations
  ['/admin/integrations', 'integrations.view'],
  ['/admin/system/cutover', 'integrations.view'],

  // Diagnostics & Engineering
  ['/admin/diagnostics', 'diagnostics.view'],
  ['/admin/sync-health', 'diagnostics.view'],
  ['/admin/system/feature-flags', 'diagnostics.view'],
  ['/admin/system/demo-pilot', 'diagnostics.view'],
  ['/admin/diagnostics/responsive-check', 'diagnostics.view'],

  // Applications & Clients — PII exposure risk via direct URL
  ['/admin/applications', 'applications.view'],
  ['/admin/clients', 'clients.view'],

  // Cards fee/limit rules — no sidebar guard, direct URL accessible
  ['/admin/cards/fee-rules', 'cards.fees.manage'],
  ['/admin/cards/limit-rules', 'cards.limits.manage'],

  // Card Program (B2B2C)
  ['/admin/card-program', 'programs.view'],

  // Payments — Inbound Suspense
  ['/admin/payments/inbound-suspense', 'payments.view'],

  // Stranded payment intents — ops triage queue (P4)
  ['/admin/payments/stranded', 'payments.stranded.view'],
  ['/admin/payment-ops/stranded', 'payments.stranded.view'],
];
